import { IntlShape } from 'react-intl'

import { DatingFields } from 'components/page/DatingProfile/DatingProfile.constants'
import { GQLForeignRootQuery } from 'components/page/ForeignProfile/gql/__generated__/ForeignRoot'
import {
  renderTextHeight,
  renderTextWeight,
} from 'components/presentational/UnitSelect'
import { GQLGender } from 'generated-graphql/graphql'

import { iconsText } from '../../Profile.constants'
import { ProfileListType } from '../../Profile.types'

export const findLexeme = (
  profile: GQLForeignRootQuery['user'],
  ui: GQLForeignRootQuery['ui'],
  listFields: DatingFields[],
  dataName: Partial<Record<DatingFields, string>>,
  intl: IntlShape,
  lgbtRestriction?: boolean,
  lgbtHidden?: boolean,
  lgbtModified?: boolean
) => {
  return listFields
    .map((item) => {
      if (
        item === DatingFields.Orientation &&
        (lgbtRestriction || lgbtHidden || lgbtModified)
      ) {
        return null
      }

      const _data = profile?.dating[item]
      const _dataLexemes = ui.glossary.datingProfile[item]

      if (_data) {
        if ([DatingFields.Height, DatingFields.Weight].includes(item)) {
          const _dataConvert = convertPhysicalData(item, _data as number, intl)

          return {
            icon: iconsText[item],
            title: _dataConvert,
            'data-name': item,
          }
        }

        const lexemes = _dataLexemes.find(({ value }) => value === _data)

        const _lexeme =
          profile?.gender === GQLGender.M
            ? lexemes.maleLexeme
            : lexemes.femaleLexeme

        const _icon =
          item === DatingFields.Appearance
            ? appearanceIcon(profile.gender)
            : iconsText[item]

        return {
          icon: _icon,
          title: _lexeme,
          ['data-name']: dataName[item],
        }
      } else {
        return null
      }
    })
    .filter((value) => value !== null) as ProfileListType[]
}

const appearanceIcon = (gender: GQLGender) => {
  const iconSwitch = iconsText[DatingFields.Appearance]
  return typeof iconSwitch === 'function' && iconSwitch(gender)
}

const convertPhysicalData = (
  field: DatingFields,
  data: number,
  intl: IntlShape
) => {
  switch (field) {
    case DatingFields.Height:
      return renderTextHeight(intl, data / 10)

    case DatingFields.Weight:
      return renderTextWeight(intl, data / 1000)
  }
}
